/**
 * @module webdnn
 */
/** Don't Remove This comment block */
/**
 * `DescriptorRunner` provides interface to execute DNN model and access input and output buffers.
 */
export class DescriptorRunner {
    constructor(option = {}) {
        /**
         * The descriptor
         */
        this.descriptor = null;
        let { transformUrlDelegate = function (url) { return url; } } = option;
        this.transformUrlDelegate = transformUrlDelegate;
    }
    /**
     * Return `true` if this backend is available in this environment.
     * @returns {boolean}
     */
    static checkAvailability() {
        return false;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/descriptor_runner/descriptor_runner/descriptor_runner.js
// module id = 7
// module chunks = 0